import { Feature } from "geojson"
import "./MapDataCard.scss"
import { IAddress, IMapLayer } from "../../../../shared/models/map_models"
import { useEffect, useState } from "react"
import { getDataFromDetailedViewConfigs } from "../../map-utils"
import { Box, DialogTitle } from "@mui/material"
import { useTheme } from '@mui/material/styles';
import MapLayerIcon from "../MapLayerIcon/MapLayerIcon"

interface IMapDataCardProps {
    feature: Feature,
    layer: IMapLayer,
    isActive: boolean,
    iconClicked?: () => void
}

const MapDataCard = (props: IMapDataCardProps) => {

    const theme = useTheme()

    const [title, setTitle] = useState<string>("")
    const [firstLine, setFirstLine] = useState<string>("")
    const [secondLine, setSecondLine] = useState<string>("")

    useEffect(() => {
        const viewConfigs = props.layer.detailed_view_configs

        const foundTitle = viewConfigs?.details?.find((x) => x.type === 'title')
        const mapData = props.feature.properties?.data

        if (!mapData) return

        if(foundTitle){
            const titleData = getDataFromDetailedViewConfigs(mapData, foundTitle) || ""
            setTitle(titleData)
        }
        const foundAddress = viewConfigs?.details?.find((x) => x.type === 'address')
        if (foundAddress){
            const addressData = getDataFromDetailedViewConfigs(mapData, foundAddress) as IAddress
            setFirstLine(`${addressData.line_1 || ''} ${addressData.line_2 || ''}`)
            let newSecondLine = ""
            if(addressData?.city){
               newSecondLine = `${addressData.city}, `
            }
            if(addressData?.state){
               newSecondLine += `${addressData.state} `
            }
            if(addressData?.zip){
                newSecondLine += `${addressData.zip}`
            }
            setSecondLine(newSecondLine)
        }
            
    }, [props.feature, props.layer])

    return (
        <Box className={"map-card"} sx={{backgroundColor: props.isActive ? theme.palette.secondary.main : ""}}>
            <div className="card-icon-wrapper">
                <MapLayerIcon  
                    mapLayer={props.layer}
                    iconClicked={props.iconClicked}
                />
            </div>
            <div className="card-content-wrapper">
                <DialogTitle className="card-title">
                    {title}
                </DialogTitle>
                {firstLine !== '' && <div>{firstLine}</div>}
                {secondLine !== '' && <div>{secondLine}</div>}
            </div>
        </Box>
    )
}

export default MapDataCard